import { gql } from "@apollo/client"
import { api } from "lib/graphql/api"
import { mutate } from "lib/graphql/mutate"

export const removeCommentarySection = api(async function removeCommentarySection({ id }) {
    return mutate(
        gql`
            mutation RemoveCommentarySection($id: String!) {
                removeCommentarySection(id: $id)
            }
        `,
        { id },
        { returns: "removeCommentarySection" }
    )
})
